import angular from 'angular'

angular.module('nominas.nomina')
  .service('NominasNominaSaldos', NominasNominaSaldos)

NominasNominaSaldos.$inject = ['$http', '$filter', '$interpolate', '$export', '$state']

function NominasNominaSaldos ($http, $filter, $interpolate, $export, $state) {
  this.get = get

  function get (idProyecto, idNomina) {
    return $http.get('/api/nominas/nomina/saldos', {
      params: {
        id_proyecto: idProyecto,
        id_nomina: idNomina,
      },
      schema: NominasNominaSaldosSchema,
      cache: 'nomina',
    }).then(function (response) {
      let data = response.data

      data.saldos = $filter('orderBy')(data.saldos, 'colaborador')

      data.editando = null

      return new NominasNominaSaldos(data)
    })
  }

  function NominasNominaSaldos (data) {
    angular.extend(this, data)
  }

  NominasNominaSaldos.prototype.generarGrid = generarGrid
  NominasNominaSaldos.prototype.exportarXLS = exportarXLS

  function generarGrid () {
    let self = this,
      nomina = generarBloqueNomina(self.id_nomina, self.id_moneda),
      nominaSaldo = generarBloqueSaldo(self.id_moneda),
      nominaAsociada = generarBloqueNomina(self.id_nomina_asociada, self.id_moneda_asociada),
      nominaAsociadaSaldo = generarBloqueSaldo(self.id_moneda_asociada)

    let grid = {
      pinnedColumnCount: 1,
      enableColResize: true,
      rowSelection: 'single',
      columnDefs: [{
        // Agregar esta columna para que se pueda filtrar por id de empleado
        headerName: 'ID',
        field: 'id_colaborador',
        hide: true,
      }, {
        // Agregar esta columna para que se pueda filtrar por nombre de empleado
        headerName: 'Colaborador',
        field: 'colaborador',
        hide: true,
      }]
        .concat(nomina)
        .concat(nominaAsociada)
        .concat(nominaSaldo)
        .concat(nominaAsociadaSaldo),
      rowData: self.saldos,
      icons: {
        groupExpanded: '<i class="fa fa-fw fa-chevron-down"></i>',
        groupContracted: '<i class="fa fa-fw fa-chevron-right"></i>',
        headerGroupOpened: '<i class="fa fa-fw fa-chevron-left"></i>',
        headerGroupClosed: '<i class="fa fa-fw fa-chevron-right"></i>',
      },
      groupUseEntireRow: false,
      groupKeys: ['empresa', 'departamento'],
      groupHeaders: true,
      groupDefaultExpanded: true,
      groupColumnDef: {
        headerName: 'Empresa > Depto. > Colaborador',
        field: 'colaborador',
        width: 350,
        minWidth: 200,
        cellStyle: empleadoStyle,
        cellRenderer: {
          renderer: 'group',
          padding: 10,
          innerRenderer: empleadoRenderer,
        },
      },
    }

    function generarBloqueNomina (idNomina, idMoneda) {
      let moneda = idMoneda === 1 ? 'mxn' : 'usd',
        headerGroup = moneda.toUpperCase()

      return idNomina ? [{
        headerName: 'Subtotal',
        headerGroup: headerGroup,
        headerGroupShow: 'open',
        field: moneda + '_subtotal',
        width: 100,
        minWidth: 80,
        cellRenderer: currencyRenderer,
        aggFunc: 'sum',
      }, {
        headerName: 'Comisión',
        headerGroup: headerGroup,
        headerGroupShow: 'open',
        field: moneda + '_comision',
        width: 100,
        minWidth: 80,
        cellRenderer: currencyRenderer,
        aggFunc: 'sum',
      }, {
        headerName: 'Neto',
        headerGroup: headerGroup,
        headerGroupShow: 'open',
        field: moneda + '_neto',
        width: 100,
        minWidth: 80,
        cellRenderer: currencyRenderer,
        aggFunc: 'sum',
      }, {
        headerName: 'Descuentos',
        headerGroup: headerGroup,
        headerGroupShow: 'open',
        field: moneda + '_descuentos',
        width: 100,
        minWidth: 80,
        cellRenderer: currencyRenderer,
        aggFunc: 'sum',
      }, {
        headerName: 'Total',
        headerGroup: headerGroup,
        field: moneda + '_total',
        width: 100,
        minWidth: 80,
        cellRenderer: currencyRenderer,
        aggFunc: 'sum',
      }] : []
    }

    function generarBloqueSaldo (idMoneda) {
      let moneda = idMoneda === 1 ? 'mxn' : 'usd'

      return {
        headerGroup: 'Saldos',
        headerName: moneda.toUpperCase(),
        field: moneda + '_saldo',
        width: 100,
        minWidth: 80,
        cellRenderer: currencyRenderer,
        cellDoubleClicked: function (params) {
          let remuneracion_moneda = idMoneda === 1 ? 2 : 1,
            remuneracion = params.data[(remuneracion_moneda === 1 ? 'mxn' : 'usd') + '_total']

          if (params.value <= 0 || remuneracion <= 0)
            return

          self.editando = {
            colaborador: params.data.colaborador,
            idProyecto: params.data.id_proyecto,
            idColaborador: params.data.id_colaborador,
            idMoneda: idMoneda,
            fechaAbono: self.fecha_abono,
            fechaCorte: self.fecha_corte,
            tipoCambio: self.tipo_cambio,
            saldo: {
              id_moneda: idMoneda,
              importe: params.value,
              tipo_cambio: idMoneda === 1 ? 1 / self.tipo_cambio : self.tipo_cambio,
            },
            remuneracion: {
              id_moneda: remuneracion_moneda,
              importe: remuneracion,
              tipo_cambio: idMoneda === 2 ? 1 / self.tipo_cambio : self.tipo_cambio,
            },
            item: params.data,
          }
        },
        cellStyle: function (params) {
          let remuneracion = params.data[(idMoneda === 1 ? 'usd' : 'mxn') + '_total']

          if (!params.node.group && params.value > 0 && remuneracion > 0)
            return {
              'font-weight': 'bold',
              'color': '#ff9800',
            }
        },
        aggFunc: 'sum',
      }
    }

    function currencyRenderer (params) {
      return angular.isNumber(params.value)
        ? '<div style="text-align: right"><span style="float: left">$</span>' + $filter('currency')(params.value, '') + '</div>'
        : ''
    }

    function percentRenderer (params) {
      return angular.isNumber(params.value)
        ? '<div style="text-align:center">' + (params.value * 100).toFixed(2) + ' %</div>'
        : ''
    }

    function empleadoStyle (params) {
      if (params.node.group) {
        return {}
      } else {
        return {color: ''}
      }
    }

    let empleadoRendererTemplate = $interpolate('<a class="{{class}}" href="{{link}}" style="text-align:center;width:50px;line-height:1.5;margin-right:4px" target="_blank" title="Informaci&oacute;n del Kardex"><code>{{idEmpleado}}</code></a> {{empleado}}')

    function empleadoRenderer (params) {
      if (params.node.group)
        return (params.node.field === 'Departamento'
          ? 'Depto. '
          : '')
          + params.node.key

      return empleadoRendererTemplate({
        idEmpresa: params.data.id_proyecto,
        idEmpleado: params.data.id_colaborador,
        link: $state.href('empleado.servicios.buscar', {
          idEmpresa: params.data.id_proyecto,
          idEmpleado: params.data.id_colaborador,
          idMoneda: self.id_moneda,
        }),
        empleado: params.value,
        class: 'link tag' + (params.data.status ? '' : ' tag-warn'),
      })
    }

    return grid
  }

  function exportarXLS () {
    let self = this,
      pages = [{
        name: 'Antiguedad de Saldos',
        details: [
          {label: 'Empresa: ' + self.empresa, cell: 'D1'},
          {label: 'Nómina: ' + self.id_nomina, cell: 'D2'},
          {label: 'Moneda: ' + (self.id_moneda === 1 ? 'MXN' : 'USD'), cell: 'D3'},
          {label: 'Nómina Asociada: ' + self.id_nomina_asociada || '', cell: 'D4'},
          {label: 'Fecha: ' + self.fecha.toYMD(), cell: 'I1'},
          {label: 'Fecha inicial: ' + self.fecha_inicial.toYMD(), cell: 'I2'},
          {label: 'Fecha final: ' + self.fecha_final.toYMD(), cell: 'I3'},
          {label: 'Fecha de pago: ' + self.fecha_pago.toYMD(), cell: 'I4'},
        ],
        columns: [
          {label: 'Empr.', format: {align: 'center', width: 4}},
          {label: 'Empl.', format: {align: 'center', width: 7}},
          {label: 'Empresa', format: {width: 30}},
          {label: 'Empleado', format: {width: 30}},
          {label: 'Dpto.', format: {width: 10}},
          {label: 'Subtotal MXN', format: {type: 'currency', align: 'right', width: 12}, totalize: true},
          {label: 'Comision MXN', format: {type: 'currency', align: 'right', width: 12}, totalize: true},
          {label: 'Neto MXN', format: {type: 'currency', align: 'right', width: 12}, totalize: true},
          {label: 'Descuentos MXN', format: {type: 'currency', align: 'right', width: 12}, totalize: true},
          {label: 'Total MXN', format: {type: 'currency', align: 'right', width: 12}, totalize: true},
          {label: 'Saldo MXN', format: {type: 'currency', align: 'right', width: 12}, totalize: true},
          {label: 'Subtotal USD', format: {type: 'currency', align: 'right', width: 12}, totalize: true},
          {label: 'Comision USD', format: {type: 'currency', align: 'right', width: 12}, totalize: true},
          {label: 'Neto USD', format: {type: 'currency', align: 'right', width: 12}, totalize: true},
          {label: 'Descuentos USD', format: {type: 'currency', align: 'right', width: 12}, totalize: true},
          {label: 'Total USD', format: {type: 'currency', align: 'right', width: 12}, totalize: true},
          {label: 'Saldo USD', format: {type: 'currency', align: 'right', width: 12}, totalize: true},
        ],
        options: {
          logo: {
            filename: '/api/export/images/FAN-logo.png',
            title: 'FAN Consultores',
            cell: 'A1',
          },
          show_grid: false,
          fixed_column: 'A8',
        },
        data: self.saldos.map(function (item) {
          return [
            item.id_proyecto,
            item.id_colaborador,
            item.empresa,
            item.colaborador,
            item.departamento,
            item.mxn_subtotal,
            item.mxn_comision,
            item.mxn_neto,
            item.mxn_descuentos,
            item.mxn_total,
            item.mxn_saldo,
            item.usd_subtotal,
            item.usd_comision,
            item.usd_neto,
            item.usd_descuentos,
            item.usd_total,
            item.usd_saldo,
          ]
        }),
      }]

    $export.excel('Antigüedad de saldos Nómina ' + self.id_nomina, pages)
  }
}

let NominasNominaSaldosSchema = {
  fecha: 'date',
  fecha_abono: 'date',
  fecha_final: 'date',
  fecha_inicial: 'date',
  fecha_pago: 'date',
  fecha_corte: 'date',
  id_moneda: 'number',
  id_moneda_asociada: 'number',
  saldos: {
    mxn_subtotal: 'number',
    mxn_comision: 'number',
    mxn_neto: 'number',
    mxn_descuentos: 'number',
    mxn_total: 'number',
    mxn_saldo: 'number',
    usd_subtotal: 'number',
    usd_comision: 'number',
    usd_neto: 'number',
    usd_descuentos: 'number',
    usd_total: 'number',
    usd_saldo: 'number',
    status: 'boolean',
  },
  tipo_cambio: 'number',
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Saldos.js